(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/create-game/assets/javascripts/create-game.js') >= 0) return;  svs.modules.push('/components/marketplace/create-game/assets/javascripts/create-game.js');

'use strict';

const _excluded = ["teamPathName"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const {
  useContext,
  useEffect,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  useHistory
} = ReactRouterDOM;
const {
  DocumentTitle
} = svs.components.lbUtils;
const {
  Loader
} = svs.components.ReactLoader;
const {
  ReactButton: Button
} = svs.ui;
const {
  resolveProductId
} = svs.utils.products;
const {
  MarketplaceBrandContext
} = svs.components.marketplace.marketplaceBrand;
const {
  CreateGameForm,
  DrawSelection,
  ProductSelection
} = svs.components.marketplace.createGame;
const {
  helpers,
  hooks
} = svs.components.marketplace.createGame;
const {
  selectors
} = svs.components.marketplaceData;
const {
  actions,
  helpers: createGameHelpers
} = svs.components.marketplaceData.createGame;
const {
  helpers: gameHelpers
} = svs.components.marketplaceData.games;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const MAX_RENDER_TIMEOUT_MS = 10 * 60 * 1000;
const {
  loadFromLocalStorage
} = svs.components.marketplaceData.localStorage.actions;
const CreateGame = () => {
  const dispatch = useDispatch();
  const _ReactRouterDOM$usePa = ReactRouterDOM.useParams(),
    {
      teamPathName
    } = _ReactRouterDOM$usePa,
    params = _objectWithoutProperties(_ReactRouterDOM$usePa, _excluded);
  const activatedDrawId = parseInt(params.activatedDrawId, 10);
  const containerId = parseInt(params.containerId, 10);
  const groupId = parseInt(params.groupId, 10);
  const history = useHistory();
  const {
    error: drawErrorMessage,
    DrawFetchState,
    draws,
    drawState,
    productDraws
  } = hooks.useDraws({
    activatedDrawId,
    containerId,
    groupId
  });
  const {
    availableProducts,
    errorMessage,
    isSelectedDrawClosed,
    selectedDraw,
    selectedProduct
  } = useSelector(state => state.CreateGame);
  const {
    getBrandedDisplayName
  } = useContext(MarketplaceBrandContext);
  const {
    redirectToGame,
    redirectToTeam
  } = hooks.useRedirectTo();
  const nextRegCloseTime = useRef();
  const game = useSelector(state => selectors.games.getGame(state, {
    activatedDrawId,
    groupId
  }));
  const me = useSelector(state => selectors.members.selectMe(state, {
    groupId
  }));
  const isEditable = Boolean(game) && gameHelpers.canMemberEditGame(me, game);
  useEffect(() => {
    if (Boolean(activatedDrawId) && errorMessage) {
      redirectToTeam();
    }
  }, [errorMessage, activatedDrawId, redirectToTeam]);
  useEffect(() => {
    if (!isEditable && activatedDrawId) {
      redirectToGame({
        activatedDrawId,
        containerId,
        groupId,
        strategy: 'push',
        teamPathName
      });
    }
  }, [activatedDrawId, containerId, groupId, isEditable, redirectToGame, teamPathName]);
  useEffect(() => {
    const productItems = createGameHelpers.getProductItems(availableProducts, draws);
    const allClosed = productItems.every(_ref => {
      let {
        isDisabled
      } = _ref;
      return isDisabled;
    });
    if (isSelectedDrawClosed && !allClosed) {
      dispatch(showDialog({
        title: 'Spelstopp är för nära',
        text: 'Spelstopp för omgången du valt är för nära. Välj en annan omgång.',
        icon: 'clock'
      }));
    }
  }, [availableProducts, dispatch, draws, isSelectedDrawClosed]);
  useEffect(() => {
    const newNextRegCloseTime = createGameHelpers.getNextDrawCloseTime(productDraws);
    const now = new Date();
    const timeUntilClose = newNextRegCloseTime.getTime() - now.getTime();
    let renderTimeout;
    if (newNextRegCloseTime && timeUntilClose < MAX_RENDER_TIMEOUT_MS) {
      if (!newNextRegCloseTime || nextRegCloseTime.current && nextRegCloseTime.current.getTime() === newNextRegCloseTime.getTime()) {
        return;
      }
      renderTimeout = setTimeout(() => {
        nextRegCloseTime.current = undefined;
        const drawItems = createGameHelpers.getDrawItems(draws[selectedProduct]);
        const selectedDrawItem = drawItems.find(_ref2 => {
          let {
            item
          } = _ref2;
          return selectedDraw === item.drawNumber;
        });
        const newSelectedDrawClosed = selectedDrawItem && selectedDrawItem.isDisabled;
        if (!isSelectedDrawClosed && newSelectedDrawClosed) {
          dispatch(actions.selectedDrawClosed(selectedDraw));
        }
      }, timeUntilClose);
      nextRegCloseTime.current = newNextRegCloseTime;
    }
    return () => {
      clearTimeout(renderTimeout);
    };
  }, [dispatch, draws, isSelectedDrawClosed, productDraws, selectedDraw, selectedProduct]);
  useEffect(() => {
    if (!activatedDrawId) {
      dispatch(actions.resetValues());
    }
  }, []);
  useEffect(() => () => dispatch(actions.clearFormAction), [dispatch]);
  useEffect(() => {
    if (!activatedDrawId) {
      dispatch(loadFromLocalStorage());
    }
  }, []);
  return React.createElement("div", {
    className: "single-column-view"
  }, React.createElement(DocumentTitle, {
    title: activatedDrawId ? 'Redigera spel' : 'Skapa spel'
  }), drawState === DrawFetchState.ERROR && React.createElement("div", {
    className: "qa-no-open-draws",
    "data-testid": "no-open-draws"
  }, drawErrorMessage ? React.createElement("p", {
    className: "f-medium"
  }, drawErrorMessage) : React.createElement(React.Fragment, null, React.createElement("p", {
    className: "f-medium"
  }, isSelectedDrawClosed ? 'Den valda omgången är stängd. Det finns inga öppna omgångar just nu.' : 'Det finns inte några öppna spelomgångar för tillfället.'), React.createElement("p", null, "F\xF6rs\xF6k igen lite senare!")), React.createElement(helpers.RedirectButton, {
    className: "qa-cancel-button",
    label: "St\xE4ng"
  })), drawState === DrawFetchState.LOADING && React.createElement("div", {
    className: "marketplace-full-height marketplace-center-container qa-loading-form-data"
  }, React.createElement(Loader, {
    inverted: true
  })), drawState === DrawFetchState.OK && React.createElement("div", {
    className: "create-game-container qa-active-form"
  }, React.createElement("div", {
    className: "margin-bottom-1 margin-md-top-3"
  }, React.createElement(ProductSelection, {
    allDraws: draws
  }), React.createElement(DrawSelection, {
    allDraws: draws
  }), errorMessage && React.createElement("p", {
    className: "margin-top-1"
  }, errorMessage), !errorMessage && productDraws.length === 0 && React.createElement("p", {
    className: "margin-top-1"
  }, "Det finns inga \xF6ppna omg\xE5ngar f\xF6r ".concat(getBrandedDisplayName(resolveProductId(selectedProduct)), ".")), productDraws.length && React.createElement(CreateGameForm, {
    isEditMode: Boolean(activatedDrawId),
    isLoading: drawState === DrawFetchState.LOADING
  }), React.createElement(Button, {
    block: true,
    className: "qa-cancel-button margin-top-3",
    onClick: () => history.goBack(),
    transparent: true
  }, "Avbryt"), React.createElement("div", {
    className: "padding-xs-bottom padding-md-bottom-2"
  }))));
};
setGlobal('svs.components.marketplace.createGame.CreateGame', CreateGame);

 })(window);